const folder = 'unternehmen/events'
export const state = () => ({
  meta: null,
  stage: null,
  intro: null,
  events: [],
  upcomingEvents: null,
  pastEvents: null,
  speakers: null,
  interviews: null
})
export const getters = {
  meta(state) {
    return state.meta
  },
  stage(state) {
    return state.stage
  },
  intro(state) {
    return state.intro
  },
  events(state) {
    return state.events
  },
  upcomingEvents(state) {
    return state.upcomingEvents
  },
  pastEvents(state) {
    return state.pastEvents
  },
  speakers(state) {
    return state.speakers
  },
  interviews(state) {
    return state.interviews
  }
}
export const mutations = {
  setMeta(state, { data }) {
    state.meta = data
  },
  setStage(state, { data }) {
    state.stage = data
  },
  setIntro(state, { data }) {
    state.intro = data
  },
  setEvents(state, { data }) {
    state.events = data
  },
  setUpcomingEvents(state, { data }) {
    state.upcomingEvents = data
  },
  setPastEvents(state, { data }) {
    state.pastEvents = data
  },
  setSpeakers(state, { data }) {
    state.speakers = data
  },
  setInterviews(state, { data }) {
    state.interviews = data
  }
}
export const actions = {
  getMeta({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/meta.json`)
      .then((res) => {
        commit('setMeta', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getStage({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/stage.json`)
      .then((res) => {
        commit('setStage', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getIntro({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/intro.json`)
      .then((res) => {
        commit('setIntro', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getEvents({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/events.json`)
      .then((res) => {
        commit('setEvents', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getUpcomingEvents({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/upcoming-events.json`)
      .then((res) => {
        commit('setUpcomingEvents', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getPastEvents({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/past-events.json`)
      .then((res) => {
        commit('setPastEvents', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getSpeakers({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/speakers.json`)
      .then((res) => {
        commit('setSpeakers', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getInterviews({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/interviews.json`)
      .then((res) => {
        commit('setInterviews', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  }
}
